import { Routes } from '@angular/router';
import { ListeEc2Component } from './pages/ListeEc2/liste-ec2.component';
import { ListeRdsComponent } from './pages/ListeRds/liste-rds.component';
import { ListeGroupComponent } from './pages/ListeGroup/liste-groups.component';
import {EditGroupComponent} from './pages/EditGroup/edit-group.component';
import { ListeRolesComponent } from './pages/ListeRole/liste-roles.component';
import { ListePermissionComponent } from './pages/ListePermission/liste-permission.component';
import { ListeUserComponent } from './pages/ListeUser/liste-users.component';

export const ClacMyCloudRoutes: Routes = [{
    path: 'ec2',
    component: ListeEc2Component
},
{
    path: 'rds',
    component: ListeRdsComponent
},
{
    path: 'settings/users',
    component: ListeUserComponent
},
{
    path: 'settings/groups',
    component: ListeGroupComponent
},
{
    path: 'settings/roles',
    component: ListeRolesComponent
},
{
    path: 'settings/permissions',
    component: ListePermissionComponent
},
{
    path: 'settings/groups/:id',
    component: EditGroupComponent
}
];
